import React, { useState } from 'react'
import { FaChartBar, FaChartPie } from 'react-icons/fa'
import PersonalDashboardSummary from './PersonalDashboardSummary'
import PersonalPerformanceChart from './PersonalPerformanceChart'
import ModuleContentAnalysis from './ModuleContentAnalysis'
import './TabbedDashboard.scss'

const TabbedDashboard = ({ moderatorAnalysis, modulesByGrade, onModuleAnalysis }) => {
  const [activeTab, setActiveTab] = useState('overview')
  const [selectedModuleId, setSelectedModuleId] = useState(null)

  const handleModuleAnalysis = (moduleId) => {
    setSelectedModuleId(moduleId)
    if (onModuleAnalysis) {
      onModuleAnalysis(moduleId)
    }
  }

  const closeModuleAnalysis = () => {
    setSelectedModuleId(null)
  }

  const tabs = [
    {
      id: 'overview',
      label: 'My Overview',
      icon: <FaChartBar />,
      component: (
        <div className="tab-content">
          {moderatorAnalysis?.payload && (
            <PersonalDashboardSummary 
              analysis={moderatorAnalysis.payload}
            />
          )}
        </div>
      )
    },
    {
      id: 'performance',
      label: 'Performance',
      icon: <FaChartPie />,
      component: (
        <div className="tab-content">
          {moderatorAnalysis?.payload && (
            <PersonalPerformanceChart analysis={moderatorAnalysis.payload} />
          )}
        </div>
      )
    }
  ]

  const activeTabData = tabs.find(tab => tab.id === activeTab)

  return (
    <div className="tabbed-dashboard">
      {/* Tab Navigation */}
      <div className="tab-navigation">
        <div className="tab-list">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content-wrapper">
        {activeTabData?.component}
      </div>

      {/* Module Content Analysis Modal */}
      {selectedModuleId && (
        <ModuleContentAnalysis 
          moduleId={selectedModuleId}
          onClose={closeModuleAnalysis}
        />
      )}
    </div>
  )
}

export default TabbedDashboard
